"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const handleError_1 = __importDefault(require("../../handleError"));
const api_1 = require("../../api");
const NumberInput_1 = __importDefault(require("../../forms/Fields/NumberInput"));
const formik_1 = require("formik");
const SurplusField_1 = __importDefault(require("../../forms/Fields/SurplusField"));
const Button_1 = __importDefault(require("../../forms/Button"));
const errorNotification_1 = require("../../errorNotification");
const Modal_1 = __importDefault(require("../../components/Modal"));
const react_helmet_1 = __importDefault(require("react-helmet"));
const react_2 = require("@headlessui/react");
const classnames_1 = __importDefault(require("classnames"));
const HandScanner_1 = __importDefault(require("../../components/HandScanner"));
const utils_1 = require("../../components/utils");
const ScannerPage = (props) => {
    const inventoryApi = new api_1.InventoryApi();
    const [current, setCurrent] = (0, react_1.useState)({ quantity: 0, surplus: 0 });
    const [quantityModalOpened, setQuantityModalOpened] = (0, react_1.useState)(false);
    const [stopStream, setStopStream] = (0, react_1.useState)(false);
    const saveInventoryRecord = async (values) => {
        if (current.plant_option_id) {
            const data = await inventoryApi.update(current.plant_option_id, values);
            (0, errorNotification_1.notify)('success', 'Lagerbestand gespeichert!');
        }
    };
    const onHandScan = async (sScancode, quantity = 0, handleSubmit, handleFormReset) => {
        // try {
        //     // @ts-ignore
        //     document!.activeElement!.blur();
        // } catch(error) {
        //
        // }
        // await sleep(200);
        handleSubmit();
        await (0, utils_1.sleep)(500);
        setQuantityModalOpened(false);
        const data = inventoryApi
            .get(sScancode)
            .then((response) => {
            setCurrent({ ...response });
            handleFormReset();
            setQuantityModalOpened(true);
        })
            .catch((error) => {
            setCurrent({ quantity: 0, surplus: 0 });
            setQuantityModalOpened(false);
            handleFormReset();
            (0, handleError_1.default)(error);
        });
    };
    const onSubmit = async (values, { setErrors, setSubmitting }) => {
        setSubmitting(true);
        try {
            await saveInventoryRecord(values);
            // setTimeout(() => {
            //     setStopStream(false);
            // },500);
        }
        catch (error) {
            setErrors(error.response.data.errors);
        }
        // resumeScanning();
        setSubmitting(false);
    };
    const onCancel = (handleReset) => {
        setCurrent({ quantity: 0, surplus: 0 });
        setTimeout(() => {
            setStopStream(false);
        }, 500);
        setQuantityModalOpened(false);
        handleReset();
    };
    // const onPhoneScan = async (code, handleFormReset) => {
    //
    //     setStopStream(true);
    //
    //     try {
    //         const data = await inventoryApi
    //             .get<PlantOptionInventory>(code);
    //         setCurrent({...data});
    //         handleFormReset();
    //         setQuantityModalOpened(true);
    //     } catch(error) {
    //         setCurrent({quantity: 0, surplus: 0});
    //         setQuantityModalOpened(false);
    //         handleFormReset();
    //         handleError(error);
    //         // resumeScanning();
    //     }
    // };
    return (react_1.default.createElement("div", { className: "container" },
        react_1.default.createElement(react_helmet_1.default, null,
            react_1.default.createElement("title", null, "Lagerbestand scannen")),
        react_1.default.createElement("div", { className: "md:flex md:items-center md:justify-between my-4" },
            react_1.default.createElement("div", { className: "flex-1 min-w-0 " },
                react_1.default.createElement("h2", { className: "text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:truncate" }, "Lagerbestand scannen")),
            react_1.default.createElement("div", { className: "mt-2 flex md:mt-0 md:ml-4" })),
        react_1.default.createElement(formik_1.Formik, { initialValues: {
                quantity: current ? current.quantity : 0,
                surplus: current ? current.surplus : 0,
            }, onSubmit: onSubmit, enableReinitialize: true }, ({ isSubmitting, handleSubmit, handleReset, values }) => (react_1.default.createElement("div", null,
            react_1.default.createElement(react_2.Tab.Group, null,
                react_1.default.createElement(react_2.Tab.List, { className: "flex space-x-1 rounded-xl bg-primary-600 bg-opacity-40 p-1 max-w-sm mx-auto mb-4" },
                    react_1.default.createElement(react_2.Tab, { key: 'hand-scanner', className: ({ selected }) => (0, classnames_1.default)('w-full rounded-lg py-2.5 text-sm font-medium leading-5 text-blue-700', 'ring-white ring-opacity-60 ring-offset-2 ring-offset-blue-400 focus:outline-none focus:ring-2', selected
                            ? 'bg-white shadow'
                            : 'text-blue-100 hover:bg-white/[0.12] hover:text-white') }, "Hand Scanner")),
                react_1.default.createElement(react_2.Tab.Panels, null,
                    react_1.default.createElement(react_2.Tab.Panel, null,
                        react_1.default.createElement(HandScanner_1.default, { handleOnScan: (code) => onHandScan(code, undefined, handleSubmit, handleReset) })))),
            react_1.default.createElement("div", null,
                react_1.default.createElement(Modal_1.default, { isOpen: quantityModalOpened, onRequestClose: () => { onCancel(handleReset); } },
                    react_1.default.createElement(formik_1.Form, { className: "space-y-4 m-4 " },
                        react_1.default.createElement("div", null,
                            react_1.default.createElement("span", { className: 'font-bold' }, "Name: "),
                            current ? current.name : ''),
                        react_1.default.createElement("div", null,
                            react_1.default.createElement("span", { className: 'font-bold' }, "EAN: "),
                            current ? current.ean : ''),
                        react_1.default.createElement(NumberInput_1.default, { name: 'quantity', label: 'Lagermenge', min: 0, classes: 'ignore-scan' }),
                        react_1.default.createElement(SurplusField_1.default, { name: 'surplus', label: 'Abgabemenge', min: 0 }),
                        react_1.default.createElement("div", { className: 'flex justify-between w-full' },
                            react_1.default.createElement(Button_1.default, { onClick: () => onCancel(handleReset), type: 'button', variant: "secondary" }, "Abbrechen"),
                            react_1.default.createElement(Button_1.default, { onClick: () => { handleSubmit(); setQuantityModalOpened(false); }, disabled: isSubmitting }, "Speichern"))))))))));
};
exports.default = ScannerPage;
